
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import { getTreeList } from "@/api/index.js";

export default new Vuex.Store({
    state: {
        menuInfo: null,
    },
    mutations: {
        setMenuInfo(state, menuInfo) {
            state.menuInfo = menuInfo
        }
    },
    actions: {
        async fetchInfo({ commit }) {
            const data = await getTreeList()
            commit('setMenuInfo', data.data)
        }
    }

})
